import {
    goToQuestion,
    goToStartPage,
    goToInterstitial,
} from '../../../../common/navigation/navigationActions';
import {
    blockScreen,
    deactivateNextButton,
    unblockScreen,
} from '../../../../common/screen/screenActions';
import selectors from '../../../../rootSelectors';
import { VOCAB } from '../../../../constants/measure';
import { QUESTIONS } from '../../../../constants/assessmentItemType';
import { narrateReset, narrateStart } from '../../../../common/audio/audioActions';
import { resetQuestionsAndTimeTrackingState } from '../../../../common/questions/questionsActions';
import { saveMeasureResponse } from '../../../../common/api/vocabActions';
import VocaboServiceClient from '../../../../common/clients/VocaboServiceClient';
import { setPlaylistItemCompleted } from '../../../../common/playlist/playlistActions';
import { TQVM_GRADES_WITH_INTERSTITIAL } from '../../../vocabConstants';
import { autoplayScript } from '../../vocabTQVMActions';
import { startQuestionTimeTracking } from '../../../../common/timeTracking/timeTrackingActions';

export const narrateQuestionsScreen = stimulusAudio => dispatch => {
    dispatch(blockScreen());
    dispatch(narrateStart());

    return dispatch(autoplayScript(stimulusAudio)).then(() => {
        dispatch(narrateReset());
        dispatch(startQuestionTimeTracking());

        return dispatch(unblockScreen());
    });
};

export const saveTQVMResponse = (response, questionIndex, isLastQuestion) => {
    return (dispatch, getStore) => {
        const state = getStore();
        const { itemId } = selectors.getVocabTQVMContent(state, QUESTIONS, questionIndex);
        const formId = selectors.getVocabTQVMFormId(state);
        const language = selectors.getCurrentLanguage(state);
        const responseId = selectors.getVocabTQVMSelectedResponseId(
            state,
            QUESTIONS,
            questionIndex,
            response,
        );

        return dispatch(
            saveMeasureResponse(
                VocaboServiceClient.MEASURES.TQVM,
                itemId,
                questionIndex,
                formId,
                language,
                responseId,
                isLastQuestion,
            ),
        );
    };
};

export const onNextQuestionButtonClick = (response, questionIndex) => {
    return (dispatch, getState) => {
        const state = getState();
        const grade = selectors.getGrade(state);
        const language = selectors.getCurrentLanguage(state);
        const isLastQuestion = questionIndex === selectors.getVocabTQVMTotalQuestions(state);

        dispatch(blockScreen());

        return dispatch(saveTQVMResponse(response, questionIndex - 1, isLastQuestion)).then(() => {
            const nextQuestion = questionIndex + 1;

            if (isLastQuestion) {
                dispatch(setPlaylistItemCompleted(VOCAB.TQVM, language));

                if (TQVM_GRADES_WITH_INTERSTITIAL.includes(grade)) {
                    return dispatch(goToInterstitial());
                }

                return dispatch(goToStartPage());
            }

            dispatch(unblockScreen());
            dispatch(deactivateNextButton());
            dispatch(resetQuestionsAndTimeTrackingState());

            return dispatch(goToQuestion(VOCAB.ASSESSMENT, VOCAB.TQVM, nextQuestion));
        });
    };
};
